module.exports = __webpack_public_path__ + "static/media/subGoogle1.81afcfef.png";